import type { HeroFormMapperData, RichTextField } from '@/types/prismicMappers'

export const getHeading = (
  type: string | undefined,
  data: HeroFormMapperData,
): RichTextField | undefined => {
  switch (type) {
    case 'repeatable-demo':
      return data.page_header
    case 'partners-details':
      return data.page_heading
    case 'offer':
      return data.hero_heading
    default:
      return data.title
  }
}

export const getDescription = (
  type: string | undefined,
  data: HeroFormMapperData,
): RichTextField | undefined => {
  switch (type) {
    case 'repeatable-demo':
    case 'partners-details':
      return data.page_description
    case 'offer':
      return data.hero_description
    default:
      return data.description
  }
}
